"use strict";

var ngModuleName = "formly";
var angular = require("./angular-fix");
var ngModule = angular.module(ngModuleName, []);

require("./providers")(ngModule);
require("./services")(ngModule);
require("./directives")(ngModule);
require("./run")(ngModule);

module.exports = ngModuleName;


/*****************
 ** WEBPACK FOOTER
 ** ./index.common.js
 ** module id = 7
 ** module chunks = 0
 **/